// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
}

.login-box {
  background: var(--white);
  padding: var(--spacing-xl);
  border-radius: var(--border-radius-xl);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 400px;
}

.login-box h2 {
  margin-bottom: var(--spacing-xl);
  color: var(--text-primary);
  text-align: center;
}

/* ⚠ 모든 규칙을 .login-box 로 스코프한다.
   스코프 없는 button/.form-group/.error-message 는 CRA 전역 CSS 특성상
   앱 전체 버튼·폼으로 새어나가 색·폭 충돌을 일으킨다. */
.login-box .form-group {
  margin-bottom: var(--spacing-lg);
  text-align: left;
}

.login-box .form-group label {
  display: block;
  margin-bottom: var(--spacing-sm);
  color: var(--text-secondary);
  font-weight: var(--font-medium);
}

.login-box .form-group input {
  width: 100%;
  padding: var(--spacing-md);
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius);
  font-size: var(--font-base);
  transition: border-color var(--transition-slow);
}

.login-box .form-group input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.login-box button {
  width: 100%;
  padding: var(--spacing-md);
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
  color: var(--white);
  border: none;
  border-radius: var(--border-radius);
  font-size: var(--font-base);
  font-weight: var(--font-medium);
  cursor: pointer;
  transition: transform var(--transition-base);
}

.login-box button:hover:not(:disabled) {
  transform: translateY(-2px);
}

.login-box button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-box .error-message {
  color: var(--danger-color);
  margin-bottom: var(--spacing-md);
  text-align: center;
  font-size: var(--font-sm);
}


`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;mCAEmC;AACnC;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,mCAAmC;EACnC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,0EAA0E;EAC1E,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".login-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);\r\n}\r\n\r\n.login-box {\r\n  background: var(--white);\r\n  padding: var(--spacing-xl);\r\n  border-radius: var(--border-radius-xl);\r\n  box-shadow: var(--shadow-xl);\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.login-box h2 {\r\n  margin-bottom: var(--spacing-xl);\r\n  color: var(--text-primary);\r\n  text-align: center;\r\n}\r\n\r\n/* ⚠ 모든 규칙을 .login-box 로 스코프한다.\r\n   스코프 없는 button/.form-group/.error-message 는 CRA 전역 CSS 특성상\r\n   앱 전체 버튼·폼으로 새어나가 색·폭 충돌을 일으킨다. */\r\n.login-box .form-group {\r\n  margin-bottom: var(--spacing-lg);\r\n  text-align: left;\r\n}\r\n\r\n.login-box .form-group label {\r\n  display: block;\r\n  margin-bottom: var(--spacing-sm);\r\n  color: var(--text-secondary);\r\n  font-weight: var(--font-medium);\r\n}\r\n\r\n.login-box .form-group input {\r\n  width: 100%;\r\n  padding: var(--spacing-md);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: var(--border-radius);\r\n  font-size: var(--font-base);\r\n  transition: border-color var(--transition-slow);\r\n}\r\n\r\n.login-box .form-group input:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.login-box button {\r\n  width: 100%;\r\n  padding: var(--spacing-md);\r\n  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);\r\n  color: var(--white);\r\n  border: none;\r\n  border-radius: var(--border-radius);\r\n  font-size: var(--font-base);\r\n  font-weight: var(--font-medium);\r\n  cursor: pointer;\r\n  transition: transform var(--transition-base);\r\n}\r\n\r\n.login-box button:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.login-box button:disabled {\r\n  opacity: 0.7;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-box .error-message {\r\n  color: var(--danger-color);\r\n  margin-bottom: var(--spacing-md);\r\n  text-align: center;\r\n  font-size: var(--font-sm);\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
